import createHttp from '@/config/http';
import type { Account } from '@/types/account';
import type { IResponseFetch, ResponseMetaData } from '@/types/service';

const http = createHttp(import.meta.env.VITE_PATIENT_URL);

// Re-export type
export type { Account };

// Account Details interface with address information
export interface AccountDetails {
	accountid: string;
	name: string;
	ta_qbocustomerid: string | null;
	address1_line1: string | null;
	address1_city: string | null;
	address1_postalcode: string | null;
	telephone1: string | null;
	address1_telephone1: string | null;
	address1_telephone2: string | null;
	emailaddress1: string | null;
}

// ========== ACCOUNTS (CLINICS) ==========
export const getAccounts = async (
	page = 1,
	limit = 50,
	search = '',
	sort = '',
	ids: string[] = [],
): Promise<{
	items: Account[];
	meta: ResponseMetaData;
}> => {
	const response = await http.get<IResponseFetch<Account>>('/accounts', {
		params: {
			page,
			limit,
			search,
			sort,
			filterIds: ids.join(','),
		},
	});
	return {
		items: response.data.data.items,
		meta: response.data.data.metaData,
	};
};

// Get Account Details by ID
export const getAccountDetails = async (
	accountId: string,
): Promise<AccountDetails | null> => {
	const response = await http.get<{
		data: AccountDetails;
		statusCode: number;
		responseMessage: string;
	}>('/accounts/details', {
		params: {
			accountId,
		},
	});
	return response.data.data;
};

